const { GkifyThemeStyles, GkifyThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new GkifyTheme.Modal();
    this.isOpen = false;

    addEventDelegate({
      selector: '.g-product-quickview-button',
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.fetchHtml(productHandle);
      },
    });

    window.GkifyEvents.subscribe(GkifyTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) GkifyTheme.ProductQuickView.close();
    });
  }

  fetchHtml(productHandle) {
    loadAssetsNew([GkifyThemeStyles.product, GkifyThemeStyles.productInventory], 'quick-view-assets');
    fetchSection('product-quickview', { url: `${window.GkifySettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector('.g-product-quickview');
        const firstModel = html.querySelector('product-model');
        this.mediaGallery = this.modalContent.querySelector('media-gallery');
        loadAssetsNew(
          [GkifyThemeScripts.productMedia, GkifyThemeScripts.variantsPicker, GkifyThemeScripts.productInventory],
          'variants-picker',
          () => {
            const colorScheme = this.modalContent.dataset.colorScheme;
            this.modal.appendChild(this.modalContent);
            this.modal.setWidth('960px');
            this.modal.open();
            this.modal.setSizes(`g-gradient ${colorScheme}`);
            this.toggleLoading(this.target, false);
            this.isOpen = true;
          }
        );
        if (firstModel) {
          loadAssetsNew(
            [
              GkifyThemeScripts.productModel,
              'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            ],
            'product-model-assets'
          );
        }
      })
      .catch(console.error);
  }

  close(e) {
    this.modal.close(e);
    this.isOpen = false;
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add('g-spinner-loading');
    } else {
      target.classList.remove('g-spinner-loading');
    }
  }
}

GkifyTheme.ProductQuickView = new QuickView();
